import {
    AttributesPanel,
    ConditionPanel,
    Conditions,
    ConsequencePanel,
    NameField,
    SalienceField,
} from '@innovatm/js-rule-editor';
import Box from '@mui/material/Box';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ResourceType } from '../../../backend';
import { ResourceRuleEditorTitle } from '../ResourceRuleEditorTitle';
import { ConsequenceBox } from './ConsequenceBox';
import { ActivatedField } from './Fields/ActivatedField';
import { ResourceTypeSelect } from './Fields/ResourceTypeSelect';

/**
 * /!\ Make sure to register values in index.ts
 */

export const EditorTitle = (
    <ResourceRuleEditorTitle
        title={<FormattedMessage id={'ruleEditor.editor.title'} />}
        tooltip={
            <>
                This editor allows you to build your Rule in a simple way.
                <br />
                You can define all fields using the form below.
            </>
        }
    />
);

export const FormFields = (
    <Box sx={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', borderRadius: '10px' }}>
        <AttributesPanel
            sx={{
                backgroundColor: 'transparent',
                borderRadius: '10px 10px 0 0',
                color: 'white',
                margin: '0px',
                '&:first-of-type': {
                    borderRadius: '10px 10px 0 0',
                },
                '&.Mui-expanded': {
                    margin: '0px',
                },
            }}
        >
            <Box>
                <NameField sx={{ width: '200px' }} />
                <SalienceField sx={{ width: '200px', marginLeft: '20px' }} />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: '30px 0 0 10px',
                }}
            >
                <ResourceTypeSelect resourceTypes={Object.values(ResourceType)} />
                <ActivatedField sx={{ marginLeft: '60px', '&.Mui-checked': { color: 'white' } }} />
            </Box>
        </AttributesPanel>
        <ConditionPanel
            sx={{
                backgroundColor: 'transparent',
                borderRadius: '0',
                color: 'white',
                margin: '0px',
                '&.Mui-expanded': {
                    margin: '0px',
                },
                '& .condition-paper, & .duration-field, & .enum-field, & .variable-field': {
                    backgroundColor: 'transparent',
                },
                '& .single-argument-operation-is, & .array-operation-is, & .parenthesis': {
                    color: 'white',
                },
                '& .object-field': {
                    backgroundColor: 'transparent',
                    color: 'white',
                },
            }}
        >
            <Conditions />
        </ConditionPanel>
        <ConsequencePanel
            sx={{
                backgroundColor: 'transparent',
                borderRadius: '0 0 10px 10px',
                color: 'white',
                margin: '0px',
                '&:last-of-type': {
                    borderRadius: '0 0 10px 10px',
                },
                '&.Mui-expanded': {
                    margin: '0px',
                },
                '& .single-argument-operation-is, & .array-operation-is, & .parenthesis': {
                    color: 'white',
                },
                '& .object-field': {
                    backgroundColor: 'transparent',
                    color: 'white',
                },
                '& .duration-field, & .enum-field, & .variable-field, & .object-field-paper': {
                    backgroundColor: 'transparent',
                },
            }}
        >
            <ConsequenceBox />
        </ConsequencePanel>
    </Box>
);
